module.exports = __webpack_public_path__ + "img/2019-12-27.74e80077.jpg";